import { useContext } from "react";
import images from "../../images";
import ProfileDropDown from "./Profile/ProfileDropDown";
import Svg from "../Helper/Svg";
import ThemeContextProvider from "../../Context/ThemeContext";
import translate from "../../Utils/translate";

export default function ThemeSelector() {
  const { changeTheme, selectedTheme, LIGHT } = useContext(ThemeContextProvider);

  return (
    <ProfileDropDown onClick={changeTheme}>
      <h1>{translate("forms.buttons.theme")}</h1>
      <Svg icon={selectedTheme === LIGHT ? images.icons.sun : images.icons.moon} />
    </ProfileDropDown>
  );
}
